export enum KYC_STATE {
    "KYC",
    "BANK_ACCOUNT",
    "COMPLETE"
}